import { defineStore } from 'pinia'

const STORAGE_KEY = 'food_invite_ref'

function normalizeInviteRef(value) {
  if (value == null) {
    return null
  }
  const code = String(value).trim()
  return code || null
}

function readInviteRefStorage() {
  if (typeof localStorage === 'undefined') {
    return null
  }
  try {
    return normalizeInviteRef(localStorage.getItem(STORAGE_KEY))
  } catch {
    return null
  }
}

function writeInviteRefStorage(code) {
  if (typeof localStorage === 'undefined') {
    return
  }
  try {
    const normalized = normalizeInviteRef(code)
    if (!normalized) {
      localStorage.removeItem(STORAGE_KEY)
      return
    }
    localStorage.setItem(STORAGE_KEY, normalized)
  } catch {
    void 0
  }
}

export const useInviteRefStore = defineStore('inviteRef', {
  state: () => ({
    inviteRef: null,
  }),
  actions: {
    restoreFromStorage() {
      this.inviteRef = readInviteRefStorage()
    },

    setInviteRef(code) {
      const normalized = normalizeInviteRef(code)
      if (!normalized) {
        return
      }
      this.inviteRef = normalized
      writeInviteRefStorage(normalized)
    },

    captureFromQuery(query = {}) {
      if (typeof query.ref === 'string') {
        this.setInviteRef(query.ref)
      }
    },
  },
})

export function buildPartnerReferralUrl(refCode, origin = window.location.origin) {
  const code = normalizeInviteRef(refCode)
  if (!code) {
    return ''
  }
  return `${origin}/?ref=${encodeURIComponent(code)}`
}
